/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateCarveOutsDocumentRequest
 */
export interface GenerateCarveOutsDocumentRequest {
    /**
     * Restrict the package to these complete carve-outs. Omit to include every complete carve-out on the submission.
     */
    carve_out_ids?: Array<string>;
}

/**
 * Check if a given object implements the GenerateCarveOutsDocumentRequest interface.
 */
export function instanceOfGenerateCarveOutsDocumentRequest(value: object): value is GenerateCarveOutsDocumentRequest {
    return true;
}

export function GenerateCarveOutsDocumentRequestFromJSON(json: any): GenerateCarveOutsDocumentRequest {
    return GenerateCarveOutsDocumentRequestFromJSONTyped(json, false);
}

export function GenerateCarveOutsDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateCarveOutsDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'carve_out_ids': json['carve_out_ids'] == null ? undefined : json['carve_out_ids'],
    };
}

export function GenerateCarveOutsDocumentRequestToJSON(json: any): GenerateCarveOutsDocumentRequest {
    return GenerateCarveOutsDocumentRequestToJSONTyped(json, false);
}

export function GenerateCarveOutsDocumentRequestToJSONTyped(value?: GenerateCarveOutsDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'carve_out_ids': value['carve_out_ids'],
    };
}

